import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import SearchBrandHomeItem from '../../components/search/SearchBrandHomeItem'
import SearchBrandProdItem from '../../components/search/SearchBrandProdItem'
import { setSelProdInfoAction } from '../../modules/common/prodModule';
import { useHistory,Link } from 'react-router-dom';
import Slider from "react-slick";
import {isMobileOnly} from 'react-device-detect';
import ProdItemSlider from '../../components/common/prod/ProdItemSlider';
import { useSelector } from 'react-redux';

const SearchBrandAndPdListBlock = styled.div`

`;

const SearchBrandAndPdListSubBlock = styled.div`

`;


const SearchBrandAndPdListUlBlock = styled.ul`
${!isMobileOnly&&"margin-left: -28px"};
list-style: none;
${isMobileOnly&&`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`};
::after {
    content: '';
    display: block;
    clear: both;
`;

const SearchBrandAndPdListLiBlock = styled.li`
margin-top: 0;
position: relative;
float: left;
    //width: 25%;
    //height: 386px;
    //margin-top: 40px;
    //padding-left: 28px;
`;

const SearchBrandAndPdListMBlock = styled.div`
    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 100px);
        padding-top: 15px;
    }

    .brand-name {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `:`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `};

        
        //width: calc(100% - 110px);
    }

    .brand-info {
        ${isMobileOnly?`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `:`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `};
    }

    .brand-home {
        font-size: 14px;
        line-height: 1.57;
        color: #111111;
        top: 6px;
        position: relative;
    }
    
    .mobile-pd-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        padding: 0 0 10px 0;
        //width: max-content;

        .pd-slider:last-child {
            padding-right: 4vw;
        }
        .pd-slider:first-child {
            margin-left: 4vw;
        }
    }
`;

const BrandThumBlock = styled.div`
    ${isMobileOnly?`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `:`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const isNull = (value) => {
    return value !== null;
}

const SearchBrandAndPdList = ({ brInfo }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    //const brandHomeInfo = brInfo._source;
    //const brandProducts = brInfo.prods;

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: true,
        //swipeToSlide: true,
      };

    const { searchText} = useSelector(
        ({ searchReducer }) => ({
            searchText: searchReducer.searchText,
        })
    );

      const handleImgClick = (id) => {
        history.push('/prod?prodid=' + id);
    }

    const handleProdClick = (prodinfo) => {
        //console.log("prod = " + JSON.stringify(prodinfo))
        history.push('/prod?prodid=' + prodinfo.prdct_id)
    }

    if (brInfo === null) {
        return <SearchBrandAndPdListLiBlock></SearchBrandAndPdListLiBlock>
    }

    if (Object.keys(brInfo).includes('prods') === false || brInfo.prods === undefined) {
        return (
            <SearchBrandAndPdListLiBlock>
                <SearchBrandHomeItem img={brInfo._source.brnd_logo_url} brandInfo={brInfo._source.brnd_han}
                idHome={brInfo._source.id} total={brInfo.totalnum} />
            </SearchBrandAndPdListLiBlock>
        );
    }

    const getProductList = () => {
        return (

                <SearchBrandAndPdListUlBlock className = "">
                {
                    brInfo.prods.map((prod,index) => {
                       return(
                            <SearchBrandAndPdListLiBlock key={prod._source.prdct_id}>
                                <SearchBrandProdItem key={prod._source.prdct_id}
                                    img={prod._source.repr_img}
                                    prodname={prod._source.prdct_nm}
                                    sale_price={prod._source.sale_price}
                                    prdct_price={prod._source.prdct_price}
                                    prdct_id={prod._source.prdct_id}
                                    onClick={() => handleImgClick(prod._source.prdct_id)}
                                />
                            </SearchBrandAndPdListLiBlock>
                        )
                    })
                }
                {isMobileOnly ? <div style={{height:'0px', margin: '0px', width:'44vw'}}></div> : ''}
                </SearchBrandAndPdListUlBlock>
        )
    }

    const getProductListSlider = () => {
        return (
            <SearchBrandAndPdListSubBlock className = "best_item-list best_item-slide clearfix slick-initialized slick-slider">
                <Slider {...settings} >
                        {
                            brInfo.prods.map((prod) => {
                                return (
                                <SearchBrandProdItem key={prod._source.prdct_id}
                                    img={prod._source.repr_img}
                                    prodname={prod._source.prdct_nm}
                                    sale_price={prod._source.sale_price}
                                    prdct_price={prod._source.prdct_price}
                                    prdct_id={prod._source.prdct_id}
                                    onClick={() => handleImgClick(prod._source.prdct_id)}
                                />
                            )
                            })
                        }
                </Slider>
            </SearchBrandAndPdListSubBlock>
        )
    }


    return (
        isMobileOnly?
        <SearchBrandAndPdListMBlock className="clearfix margin_b-40">
            <div className="clearfix margin_b-20">
                <div className="container-left">
                    <Link to={"/brHome/" + brInfo._source.id + "?q=" + searchText}>
                        <BrandThumBlock backgroundimage={brInfo._source.brnd_thumb_url.replace(/ /g, "%20")} />
                    </Link>
                </div>
                <div className="container-right">
                    <div className="clearfix">
                        <div className="f-left brand-name">
                            <Link to={"/brHome/" + brInfo._source.id + "?q=" + searchText}>
                                        {brInfo._source.brnd_han}( <span>{brInfo.totalnum}</span> )
                            </Link>
                        </div>
                    </div>
                    <div >
                        <div className="brand-info">
                        {brInfo._source.brnd_info_brief}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{width:'100vw', marginLeft:'-4vw'}}>
                {
                    brInfo.prods === null ? '' :
                    <div className="mobile-pd-conatiner">
                        {
                        brInfo.prods.map((curprod) => {
                            return (
                                <ProdItemSlider key={curprod._source.prdct_id}
                                    img={curprod._source.repr_img}
                                    prodname={curprod._source.prdct_nm}
                                    sale_price={curprod._source.sale_price}
                                    prdct_price={curprod._source.prdct_price}
                                    brandname={curprod._source.brnd_han}
                                    isBrandShow={false}
                                    clickHandler={handleProdClick}
                                    prdct_id={curprod._source.prdct_id}
                                    brandid={curprod._source.brnd_id}
                                    prodinfo={curprod._source} />
                            )
                        })
                    }
                    </div>
                }
            </div>
        </SearchBrandAndPdListMBlock>
        :
        <div>
        <SearchBrandAndPdListBlock className = "sr-brand_item margin_b-50">
            {/* <SearchBrandHomeItem img={brandHomeInfo.brnd_logo_url} brandInfo={brandHomeInfo.brnd_info_brief}
                idHome={brandHomeInfo.id} brInfo={brInfo} /> */}
                <SearchBrandHomeItem img={brInfo._source.brnd_logo_url} brandInfo={brInfo._source.brnd_han}
                idHome={brInfo._source.id} total={brInfo.totalnum} isDefault={false}/>
                {!isMobileOnly&&brInfo.totalnum > 4 ? getProductListSlider():getProductList()}

        </SearchBrandAndPdListBlock>
        </div>
    );

};

export default SearchBrandAndPdList;
